<template lang="pug">
    div(class="relative bg-white w-full h-screen flex flex-col overflow-x-hidden")
        div(class="h-screen max-h-screen")
            div(class="flex items-center justify-between pl-10 pr-3 h-12 text-black uppercase font-bold bg-gray-lighter border-b border-gray-light") Filter

            div(class="overflow-y-auto h-[calc(100vh-56px)] pb-36")

                SameDayShipping(
                    v-if="catalogData.showSameDayShippingFacet"
                    class="border-b-2 border-gray-lighter"
                    @onFitmentSelection="closeFilterMenu"
                )

                ul
                    //- Display the category filter if sub categories exist
                    li(
                        v-if="categoryGroup.values.length > 0"
                        class="block pl-10 text-sm text-black border-b-2 border-gray-lighter"
                    )
                        SubMenu(
                            ref="filterSubMenu"
                            :data="categoryGroup"
                            :filterSubMenu="filterSubMenu"
                            @onFilterSubMenuClose="closeSubMenu"
                        )
                            template(#title) {{categoryGroup.title}}
                            template(#content)
                                CategoryList(
                                    :data="categoryGroup"
                                    @onFilterMenuClose="closeFilterMenu"
                                )

                    template(v-for="facet in catalogData.facets")
                        li(
                            v-if="refinements(facet.facet).length > 0"
                            class="block pl-10 text-sm text-black border-b-2 border-gray-lighter"
                        )
                            SubMenu(
                                ref="filterSubMenu"
                                :data="facet"
                                :filterSubMenu="filterSubMenu"
                                @onFilterSubMenuClose="closeSubMenu"
                            )
                                template(#title) {{facet.text}}
                                template(#content)
                                    FilterList(:data="facet")

</template>

<script>
import SubMenu from './subMenu'
import FilterList from './filterList'
import CategoryList from './categoryList'
import SameDayShipping from './sameDayShipping'
import FilterSlideMenuMixin from './mixins'

export default {
    name: 'FilterMenu',
    components: {
        SubMenu,
        SameDayShipping,
        FilterList,
        CategoryList,
    },
    mixins: [FilterSlideMenuMixin],
    props: {
        // String name of the sub menu that is currently open; taken from the catalog data facet.text
        filterSubMenu: {
            type: String,
            default: null, // Possible values 'Category' or a facet.text value
        },
    },
    computed: {
        catalogData() {
            return this.$store.state.catalog.data
        },
    },
    methods: {
        refinements(facet) {
            const refinements = this.$searchContext.state.refinements[facet] || []
            return refinements.filter(({ isValid }) => isValid)
        },
        closeFilterSubMenu() {
            // Close each sub menu
            this.$refs.filterSubMenu.forEach((ref) => {
                ref.closeMenu()
            })
            this.closeSubMenu()
        },
        closeSubMenu() {
            this.$emit('closeFilterSubMenu')
        },
        closeFilterMenu() {
            this.$emit('closeFilterMenu')
        },
    },
}
</script>
